import React, { useState, useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CustomTooltip } from "../CustomTooltip";
import useAuth from "../../Context/useAuth";
import { authService } from "../../Service/Axios";
import { USER_URL } from "../../Constant/api";
import { useMenuList } from "../../Constant/apiHooks";
import { USER_TYPE } from "../../Constant/constants";
import { paths } from "../../Constant/paths";

const PrivateSidebar = () => {
  const { t } = useTranslation();

  const { user, isSiderbarToggle } = useAuth();
  const { projectid } = useParams();

  const [projectList, setProjectList] = useState([]);
  const [duplicateMenuList, setDuplicateMenuList] = useState([]);
  const [search, setSearch] = useState("");

  // Check localStorage for the initial theme preference
  const [isDark, setIsDark] = useState(() => {
    return localStorage.getItem("theme") === "dark";
  });

  const { menuList, orginalMenuList } = useMenuList();

  // paths
  const { admin, applicant, formBuilder, common } = paths;

  // Toggle
  const handleToggleTheme = () => {
    setIsDark(!isDark);
    localStorage.setItem("theme", isDark ? "light" : "dark");
  };

  // Listing
  const getMenuList = async () => {
    const data = {};
    const response = await authService(USER_URL, "POST", data);
    setProjectList(response);
    setDuplicateMenuList(response);
  };

  useEffect(() => {
    getMenuList();
  }, []);

  // Search
  const handleSearch = (value) => {
    let newArr = [...duplicateMenuList];
    setSearch(value);
    if (value.length > 0) {
      const searchedFilter = newArr.filter((option) =>
        option.name.toLowerCase().includes(value.toLowerCase())
      );
      setProjectList(searchedFilter);
    } else {
      setProjectList(duplicateMenuList);
    }
  };

  const filteredMenuList = useMemo(() => {
    const defaultOptions = [
      {
        key: "studentDashboard",
        href: applicant.dashboard,
        icon: "pluto-home nav_icon",
        label: t("common.button.home"),
      },
      {
        key: "adminDashboard",
        href: admin.dashboard,
        icon: "pluto-home nav_icon",
        label: t("common.button.home"),
      },
      {
        key: "adminSettings",
        href: admin.settings.root,
        icon: "pluto-status nav_icon",
        label: t("common.button.adminSetting"),
      },
      {
        key: "formBuilder",
        href: formBuilder.dashboard,
        icon: "bx bx-layout nav_icon",
        label: t("common.button.formBuilder"),
      },
      {
        key: "workflow",
        href: formBuilder.workflow,
        icon: "bx bx-layout nav_icon",
        label: t("common.button.workflow"),
      },
      {
        key: "email",
        href: admin.email,
        icon: "bx bx-envelope nav_icon",
        label: t("common.button.email"),
      },
      {
        key: "Event",
        href: admin.events.root,
        icon: "bx bx-clipboard nav_icon",
        label: t("common.button.event"),
      },
      {
        key: "recommendation",
        href: `${admin.recommendation}/recommendation`,
        icon: "pluto-socialfeed nav_icon",
        label: t("common.button.recommendation"),
      },
      {
        key: "OfferLetter",
        href: admin.offerLetter.root,
        icon: "bx bx-clipboard nav_icon",
        label: t("common.button.offerLetter"),
      },
      {
        key: "CareerHub",
        href: common.careerHub,
        icon: "bx bx-briefcase nav_icon",
        label: t("common.button.careerHub"),
      },
    ];
    const customOptions = orginalMenuList
      .filter((option) => option.link !== null)
      .map((option) => ({
        key: option.gid,
        href: option.link,
        icon: "bx bx-link-alt nav_icon",
        label: option.name,
      }));
    return [
      ...defaultOptions.filter((option) => menuList.includes(option.key)),
      ...customOptions,
    ];
  }, [menuList, orginalMenuList]);

  useEffect(() => {
    // Apply the saved theme className to the body
    if (isDark) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [isDark]);

  return (
    <>
      <div
        className={
          isSiderbarToggle
            ? "nav-sidebar text-slate-900 bg-grey-100 dark-text-slate-50 dark-bg-grey-800"
            : "nav-sidebar text-slate-900 bg-grey-100 dark-text-slate-50 dark-bg-grey-800 show"
        }
        id="nav-bar"
      // style={{
      //   backgroundColor:
      //     user && user.primaryColor ? user.primaryColor : "#182A58",
      // }}
      >
        <nav className="nav">
          <Link
            to={
              user.type === USER_TYPE.Applicant
                ? applicant.dashboard
                : admin.dashboard
            }
            className="nav_logo"
          >
            <span className="flex-none w-10">
              <img
                src="/assets/images/logo-dark.svg"
                alt=""
                className="light-logo w-10"
              />
              <img
                src="/assets/images/logo-light.svg"
                alt=""
                className="dark-logo w-10"
              />
            </span>
            <span className="nav_logo-name">
              Pluto<span className="text-color-switch">Edu</span>
            </span>
          </Link>
          <div className="d-flex flex-column common-nav">
            <ul className="nav-accordion nav_list" id="accordionSidemenu">
              {filteredMenuList &&
                filteredMenuList.length > 0 &&
                filteredMenuList.map((menu) => (
                  <li className="nav_link" key={menu.key}>
                    <Link to={menu.href}>
                      <i className={menu.icon}></i>
                      <span className="nav_name">{menu.label}</span>
                    </Link>
                  </li>
                ))}

              <li
                className="search-div my-1"
              // style={{
              //   backgroundColor:
              //     user && user.primaryColor ? user.primaryColor : "#182A58",
              // }}
              >
                <div className="p-2">
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <i className="pluto-search"></i>
                    </span>
                    <input
                      type="search"
                      className="form-control border-start-0"
                      placeholder={t("common.placeHolder.searchPositions")}
                      value={search}
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </div>
                </div>
                <ul className="search-accordion pb-3" id="searchList">
                  {projectList &&
                    projectList.length > 0 &&
                    projectList.map((menu) => {
                      return (
                        <li
                          className={menu.gid === projectid ? "active" : ""}
                          key={menu.id}
                        >
                          <CustomTooltip text={menu.name}>
                            <Link to={`${admin.projects}/${menu.gid}`}>
                              {menu.name}
                            </Link>
                          </CustomTooltip>
                        </li>
                      );
                    })}
                </ul>
              </li>
              <li className="nav_link ">
                <Link to="/">
                  <i className="pluto-termscondition nav_icon"></i>
                  <span className="nav_name">
                    {t("common.button.termsAndCondition")}
                  </span>
                </Link>
              </li>
            </ul>

            {menuList.includes("Event") && (
              <div className="p-3 mt-auto">
                <div className="sidebar-event-box p-4 rounded-3 bg-slate-200 d-flex flex-column gap-2 text-center">
                  <div>
                    <img
                      src="/assets/images/event-icon.png"
                      alt="Event"
                      width={40}
                    />
                  </div>
                  <h4 className="mb-0 text-sm font-bold">
                    Discover PlutoEdu Events!
                  </h4>
                  <p className="mb-0 text-xs">
                    All upcoming events in one place.
                  </p>
                  <Link
                    to={admin.events.root}
                    className="btn btn-primary d-flex justify-content-center align-items-center mt-2"
                  >
                    Explore Now{" "}
                    <span className="material-symbols-outlined">
                      chevron_right
                    </span>
                  </Link>
                </div>
              </div>
            )}
          </div>

          {/* <div className="admin-box dropend">
            <div
              className="dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {user && (
                <>
                  <div className="admin-img">
                    {user.photoURL ? (
                      <img
                        src={user.photoURL}
                        alt={`${user.firstName}${user.lastName}`}
                      />
                    ) : (
                      getFirstLetterOfName(user)
                    )}
                  </div>
                  <div className="admin-info ms-2">
                    <h6>
                      {user.firstName} {user.lastName}
                    </h6>
                    <small>{user.type}</small>
                  </div>
                </>
              )}
            </div>
            <ul className="dropdown-menu">
              <li>
                <Link
                  className="dropdown-item"
                  to={common.accountSetting}
                >
                  <i className="bx bx-cog"></i>{" "}
                  {t("common.button.accountSetting")}
                </Link>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  <i className="bx bx-user-circle"></i>{" "}
                  {t("common.button.buildPortfolio")}
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  <i className="bx bx-shield-quarter"></i>{" "}
                  {t("common.button.securityAndPrivacy")}
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  <i className="bx bx-globe"></i> {t("common.button.language")}
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  <i className="bx bxs-layer"></i>{" "}
                  {t("common.button.documents")}
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  <i className="bx bx-adjust"></i>{" "}
                  {t("common.button.changeTheme")}
                </a>
              </li>
              <li className="dropdown-logout">
                <button
                  className="btn btn-secondary btn-block"
                  onClick={Logout}
                >
                  {t("common.button.signOut")}
                </button>
              </li>
            </ul>
          </div> */}

          <div className="position-absolute p-3 start-0 bottom-0 end-0">
            <div className="color-theme-switch p-1 rounded-3 bg-grey-200">
              {/* <div className="btn-group w-100" role="group" aria-label="Basic outlined example">
                <button type="button" className="btn btn-primary">Light</button>
                <button type="button" className="btn btn-primary">Dark</button>
              </div> */}
              <div
                className="d-flex w-100"
                role="group"
                aria-label="Theme toggle"
              >
                <button
                  type="button"
                  className={`btn ${!isDark ? "btn-dark" : "btn-transparent"
                    } w-100 text-grey-50 d-flex align-items-center gap-1 border-0`}
                  onClick={handleToggleTheme}
                >
                  <span className="material-symbols-outlined">light_mode</span>{" "}
                  Light
                </button>
                <button
                  type="button"
                  className={`btn ${isDark ? "btn-light" : "btn-transparent"
                    } w-100 d-flex align-items-center gap-1 border-0`}
                  onClick={handleToggleTheme}
                >
                  <span className="material-symbols-outlined">dark_mode</span>{" "}
                  Dark
                </button>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div className="mobile-nav">
        <ul className="d-flex flex-row nav">
          <li className="col nav-item">
            <Link
              className="nav-link"
              to={
                user.type === USER_TYPE.Applicant
                  ? applicant.dashboard
                  : admin.dashboard
              }
            >
              <i className="pluto-home nav_icon"></i>
              <span className="nav_name">{t("common.button.home")}</span>
            </Link>
          </li>
          <li className="col nav-item">
            <Link
              className="nav-link"
              to={
                user?.type === USER_TYPE.Applicant
                  ? applicant.email
                  : admin.email
              }
            >
              <i className="pluto-message nav_icon"></i>{" "}
              <span className="nav_name">{t("common.button.email")}</span>
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default PrivateSidebar;
